import { render, staticRenderFns } from "./k8.vue?vue&type=template&id=512cbcac&"
import script from "./k8.vue?vue&type=script&lang=js&"
export * from "./k8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports